<div class="grid-container full-height full v-pad">
  <div class="form-width">

    @if (displayEditor) {
      <div id="editLetter">
        <div class="user-form-max-width">
          <h2>Editor</h2>
          <div [formGroup]="form">
            <div formControlName="updatedContents" id="updatedContents" name="updatedContents" [froalaEditor]="froalaOptions" [(ngModel)]="updatedLetterHtml"> </div>
          </div>
          <div class="cell large-12 text-align-left"><br /></div>
          <div>
            <button (click)="togglePreview()" class="button">
              {{togglePreviewText}}
            </button>
          </div>
        </div>
      </div>
    }

    @if (!displayEditor) {
      <div class="grid-x grid-margin-x">
        @if (isLoading$ | async) {
          <div class="cell large-12 text-center">
            Generating PDF Preview...
          </div>
        }
        @if (pdfAvailable) {
          <div class="cell large-12 text-right">
            <button (click)="download()" class="button">
              Download <svg-icon icon="icon-download" class="white"></svg-icon>
            </button>
            <a style="display:none" href="" target="_blank" #downloadLink rel="noopener noreferrer"></a>
          </div>
          <div class="cell large-6 text-align-left">
            <button (click)="previousPage()" class="button small" [disabled]="currentPage === 1">
              <svg-icon icon="icon-chevron-left" class="white small"></svg-icon> Previous
            </button>
          </div>
          <div class="cell large-6 text-align-right">
            <button (click)="nextPage()" class="button small" [disabled]="currentPage === totalPages">
              Next <svg-icon icon="icon-chevron-right" class="white small"></svg-icon>
            </button>
          </div>
		  <div class="cell large-12 text-center">
			  <ngx-extended-pdf-viewer [src]="pdfUrl" [textLayer]="true" [showAll]="false" [page]="currentPage" [showToolbar]="false" (pdfLoaded)="onLoadComplete($event)" class="display-block border-one-pixel-solid"></ngx-extended-pdf-viewer>
		  </div>
          <div class="cell large-12 text-align-left"><br/></div>
          <div class="cell large-6 text-align-left">
            <button (click)="togglePreview()" class="button">
              {{togglePreviewText}}
            </button>
          </div>
          <div class="cell large-6 text-align-right">
            <button (click)="createLetter()" class="button">
              Create Letter And Send to Mailer
            </button>
          </div>
        }
        @if (showError) {
          <div class="cell large-12 text-center">
            Unable to render the PDF.
          </div>
        }
        @if (displayGroupAssignment) {
          <div class="cell small-12"></div>
          <div class="user-form-max-width">
            <h2>Please Choose the group you wish to assign the next level of review to:</h2>
            <ng-select [(ngModel)]="selectedGroup" [items]="allGroups" bindLabel="displayName" placeholder=""></ng-select>
          </div>
        }
      </div>
    }
  </div>
</div>


